import React, { useState } from 'react'
import 'react-image-gallery/styles/css/image-gallery.css'
import ImageGallery from 'react-image-gallery'
import '../propertyNewHome_styles/propertyNewHome.css'
import ImageUploading from 'react-images-uploading'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { New_Upload_Img } from '../Property_Api'
import Swal from 'sweetalert2'
import { CircularProgress } from '@mui/material'
import { Delete_Image } from '../Edit_Propetry/Edit_Propetry_Api'

interface PropertyImageUploadDataType {
  id: string
  propertyImages: {
    property_image_path: string
    property_image_uuid: string
  }[]
  propertyImageLoading: boolean
  get_view_property: () => Promise<void>
  get_Img: () => Promise<void>
}
interface imagesDataType {
  data_url: string
  file: File
}

const PropertyImageUpload = ({
  id,
  propertyImages,
  propertyImageLoading,
  get_view_property,
  get_Img,
}: PropertyImageUploadDataType) => {
  const [images, setImages] = useState<imagesDataType[]>([])
  const [uploadImagesLoading, setUploadImagesLoading] = useState<boolean>(false)
  const [manageImage, setManageImages] = useState<boolean>(false)

  const initialValues = {
    document_type: '',
    document_name: '',
  }

  const propertyImagesArray = () => {
    const imageArray = propertyImages?.map((item) => ({
      original: item.property_image_path,
      thumbnail: item.property_image_path,
    }))
    return imageArray
  }

  const validationSchema = Yup.object({
    document_type: Yup.string().required('Please select any one'),
    document_name: Yup.string().required('Document name is required'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: () => console.log(),
  })
  const onChange = (imageList: any) => {
    setImages(imageList)
  }

  const handleImageUpload = () => {
    let uploadarray: filesDataType[] = []
    if (images.length > 0) {
      setUploadImagesLoading(true)
      images.map((image) => {
        // @ts-ignore
        const file = image.file
        const reader = new FileReader()
        reader.onloadend = async () => {
          const base64String = reader.result
          // @ts-ignore
          uploadarray.push({ file: base64String.split(',')[1] })
          if (images.length === uploadarray.length && uploadarray) {
            // @ts-ignore
            const res = await New_Upload_Img(id, uploadarray)
            if (res.status === 200) {
              setUploadImagesLoading(false)
              get_Img()
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: res.data.msg.charAt(0).toUpperCase() + res.data.msg.slice(1),
                text: res.data.msg_details,
                allowOutsideClick: true,
              })
            } else {
              setUploadImagesLoading(false)
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: res.data.msg.charAt(0).toUpperCase() + res.data.msg.slice(1),
                text: res.data.msg_details,
                allowOutsideClick: true,
              })
            }
          }
          setImages([])
        }
        reader.readAsDataURL(file)
      })
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'No image found',
        text: 'No image is present to upload',
        allowOutsideClick: true,
      })
    }
  }
  interface filesDataType {
    file: string
  }

  const handleDeleteImage = async (property_image_uuid: string) => {
    Swal.fire({
      title: 'Are you sure you want to archive this image?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { data: res } = await Delete_Image(
            property_image_uuid
          )
          if (res.code === '200') {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
              text: res.msg_details,
              allowOutsideClick: true,
            })
            get_Img()
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
              text: res.msg_details,
              allowOutsideClick: true,
            })
          }
        }
        catch (error: any) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error',
            text: error,
            allowOutsideClick: true,
          })
        }
      }
    })
  }

  return (
    <>
      {propertyImageLoading ? (
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{ height: '70vh' }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div className='card mb-5 mb-xl-10 overflow-hidden'>
          <div className='card-header cursor-pointer'>
            <div className='card-title m-0'>
              <h3 className='fw-bold m-0'>Images</h3>
            </div>

            <div className='align-self-center'>
              {(propertyImages?.length > 0 &&
                manageImage === true) &&
                <button
                  className='btn btn-sm btn-light fw-bold bg-color-white shadow me-4 btn-active-light-primary'
                  onClick={() => setManageImages(false)}
                >
                  Cancel
                </button>
              }

              {propertyImages?.length > 0 &&
                <button
                  type='submit'
                  className='btn btn-sm btn-primary shadow'
                  onClick={() => setManageImages(true)}
                >
                  <span> Manage Images</span>
                </button>
              }
            </div>
          </div>
          <div className='pb-5 container p-10' data-kt-stepper-element='content'>
            {propertyImages?.length > 0 && manageImage === false ? (
              <div className='image-gallery-container'>
                {/* {propertyImageLoading ? (
                  <span
                    className='d-flex justify-content-center align-items-center'
                    style={{height: '50vh'}}
                  >
                    <CircularProgress />
                  </span>
                ) : ( */}
                {/* {propertyImages && ( */}
                <ImageGallery
                  items={propertyImagesArray()}
                  additionalClass='image-gallery-slide123'
                />
                {/* )
                } */}
              </div>
            ) : (
              <div className='w-100'>
                <>
                  {
                    propertyImages?.length > 0
                    &&
                    <>
                      <div className='row mb-7'>
                        <p className='text-muted fs-5 fw-bold mb-1'>Archive Uploaded Images</p>
                        {propertyImages?.map((image, index: number) => (
                          <div className='my-1 col-lg-2 col-4 h-65px mb-5' key={index}>
                            <div className='h-50px w-100 shadow-lg'>
                              <img
                                className='h-100 w-100 rounded-top'
                                style={{ objectFit: 'cover' }}
                                src={image['property_image_path']}
                                alt=''
                              />
                              <button
                                className='d-flex align-items-center w-100 justify-content-center p-0 h-25px btn btn-light btn-sm col-6 rounded-0 rounded-bottom image_icon'
                                title='Archive'
                                onClick={() => handleDeleteImage(image.property_image_uuid)}
                              >
                                <i className='bi bi-trash text-danger fa-md fs-2'></i>
                                <span>Archive</span>
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                      <hr className='mt-7 mb-4' />
                    </>
                  }
                </>
                {
                  (propertyImages?.length < 15 || propertyImages === undefined)
                  &&
                  <>
                    {
                      propertyImages?.length > 0 &&
                      <p className='text-muted fs-5 fw-bold my-1'>Upload More Images</p>
                    }
                    <ImageUploading
                      multiple
                      value={images}
                      onChange={onChange}
                      maxNumber={15 - propertyImages?.length}
                      dataURLKey='data_url'
                    >
                      {({
                        imageList,
                        onImageRemoveAll,
                        onImageUpload,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                        errors,
                      }) => (
                        <div>
                          <div className='row border border-2 rounded border-dashed p-2'>
                            <button
                              onClick={onImageUpload}
                              {...dragProps}
                              className={`${images.length === 0 ? `col-12` : `col-lg-3 col-12`
                                } border border-2 rounded border-primary border-dashed h-100 symbol bg-light-primary py-6`}
                            >
                              <div className='d-flex flex-column'>
                                <span className='text-muted fw-bold'>{`${propertyImages?.length + images.length} out of 15 uploaded`}</span>
                                <i className='bi bi-image-fill fs-4x btn btn-active-color-primary'></i>
                                <label
                                  className='d-flex flex-column'
                                  htmlFor='file-upload'
                                  style={{ cursor: 'pointer' }}
                                >
                                  <span className='text-primary fs-9'>Click or drag and drop here</span>
                                  <span className='text-primary fs-9'>
                                    Type:*.png, *.jpeg or *.jpg, Max images:15
                                  </span>
                                </label>
                              </div>
                            </button>
                            <div
                              className={`${images.length === 0 ? `d-none` : `col-lg-9 col-12 h-100 row ms-2`}`}
                            >
                              {imageList.map((image, index) => (
                                <div className='my-1 col-lg-2 col-4 h-25' key={index}>
                                  <div className='h-55px w-100'>
                                    <img
                                      className='h-35px w-100 rounded-top'
                                      style={{ objectFit: 'cover' }}
                                      src={image['data_url']}
                                      alt=''
                                    />
                                    <div className='d-flex rounded-bottom shadow-lg'>
                                      <button
                                        className='d-flex align-items-center w-50 justify-content-center p-0 h-20px btn btn-light btn-sm col-6 rounded-0 rounded-bottom image_icon'
                                        title='Edit'
                                        onClick={() => onImageUpdate(index)}
                                      >
                                        <i className='bi bi-pencil-square text-primary fa-md fs-6'></i>
                                      </button>
                                      <button
                                        className='d-flex align-items-center w-50 justify-content-center p-0 h-20px btn btn-light btn-sm col-6 rounded-0 rounded-bottom image_icon'
                                        title='Delete'
                                        onClick={() => onImageRemove(index)}
                                      >
                                        <i className='bi bi-trash text-danger fa-md fs-6'></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          <div className='w-100 d-flex flex-column'>
                            {errors && (
                              <div className='h-20px mx-auto my-2'>
                                {errors.maxNumber && (
                                  <span className='fv-help-block color-red'>
                                    Number of selected images exceed 15
                                  </span>
                                )}
                                {errors.acceptType && (
                                  <span className='fv-help-block color-red'>
                                    Your selected file type is not allow
                                  </span>
                                )}
                                {errors.maxFileSize && (
                                  <span className='fv-help-block color-red'>
                                    Selected file size exceed maxFileSize
                                  </span>
                                )}
                                {errors.resolution && (
                                  <span className='fv-help-block color-red'>
                                    Selected file is not match your desired resolution
                                  </span>
                                )}
                              </div>
                            )}
                            <div className='mx-auto my-2 mt-5'>
                              <button
                                className='btn btn-sm btn-light fw-bold bg-color-white shadow me-4 btn-active-light-primary'
                                style={{ cursor: 'pointer' }}
                                onClick={onImageRemoveAll}
                              >
                                Reset images
                              </button>
                              <button
                                className='btn btn-sm btn-primary shadow'
                                style={{ cursor: 'pointer' }}
                                onClick={handleImageUpload}
                                disabled={uploadImagesLoading}
                              >
                                {uploadImagesLoading ? (
                                  <span className='indicator-progress' style={{ display: 'block' }}>
                                    Processing...
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                  </span>
                                ) : (
                                  'Upload images'
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </ImageUploading></>
                }

              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default PropertyImageUpload
